import React from "react";
import { ITabSetCategory } from "../../interfaces/ITabSetCategory";

function mapCategories(categories: ITabSetCategory[]) {
  return categories.map((c) => {
    return (
      <div className="wbm-row" key={c.id}>
        <a href={c.linkUrl}>{c.name}</a>
      </div>
    );
  });
}

function splitIntoColumns(categories: ITabSetCategory[], columnCount: number) {
  let currentColumn = 0;
  const columns: ITabSetCategory[][] = [];

  for (let i = 0; i < columnCount; i++) {
    columns.push([]);
  }

  for (let i = 0; i < categories.length; i++) {
    columns[currentColumn].push(categories[i]);
    currentColumn++;
    if (currentColumn >= columnCount) {
      currentColumn = 0;
    }
  }

  return columns;
}

export interface IDataDrivenMegaMenuProps {
  categories: ITabSetCategory[];
}

function DataDrivenMegaMenu(props: IDataDrivenMegaMenuProps) {
  const columns = splitIntoColumns(props.categories, 4);

  // prettier-ignore
  return (
    <>
      <span 
      className="wbm-col-3"
      >{mapCategories(columns[0])}</span><span 
      className="wbm-col-3"
      >{mapCategories(columns[1])}</span><span 
      className="wbm-col-3"
      >{mapCategories(columns[2])}</span><span 
      className="wbm-col-3"
      >{mapCategories(columns[3])}</span>
    </>
  );
}

export default DataDrivenMegaMenu;
